import type { Row } from "../../Table/Table.types";
import type {
  FilterProps,
  FilterTypes
} from "../TableFilters/TableFilters.type";

export type TColumnProps = {
  children: React.ReactNode;
  /**
   * The unique identifier for the column.
   */
  id: string;
  width?: number;
  /**
   * Cell renderer function for custom formatting
   */
  cell?: (props: { row: Row<any>; getValue: () => any }) => React.ReactNode;
  /**
   * Whether the column can be resized or not.
   * @default true
   */
  canResize?: boolean;
  /**
   * Whether the column can be sorted or not. Only passing this prop will
   * enable client-side sorting.
   * @default false
   */
  canSort?: boolean;
  /**
   * Callback function for sorting the column with server-side sorting.
   * While using this prop, you should handle the sorting logic in the parent
   * component. Pass sorted rows.
   * @param sortOrder The order in which the column should be sorted.
   */
  onSort?: (sortOrder?: "asc" | "desc") => void;
  /**
   * Whether the column can be filtered or not. Only passing this prop will
   * enable client-side filtering.
   * @default false
   */
  canFilter?: boolean;
  /**
   * The variant of the filter to be used. Only applicable when `canFilter` is
   * true.
   * @default "text"
   */
  filterType?: FilterTypes;
  /**
   * The configuration for the filter. Only applicable when `canFilter` is
   * true.
   */
  filterProps?: FilterProps;
  /**
   * Callback function for filtering the column with server-side filtering.
   * While using this prop, you should handle the filtering logic in the parent
   * component. Pass filtered rows.
   * @param filterValue The value to be used for filtering the column.
   */
  onFilter?: (filterValue: any) => void;
};

export const TColumn = ({ children }: TColumnProps) => {
  return <>{children}</>;
};
